import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; // Import Link from React Router
import BlogCard from '../components/BlogCard';
import TravelMap from '../components/TravelMap';
import '../styles/Home.css';
import blogs from '../configs/blogData';

const Home = () => {
  const sorted_blogs = [...blogs].sort((a, b) => new Date(b.date) - new Date(a.date));
  const baseUrl = 'https://jermingo.com';
  
  useEffect(() => {
    // Update document title
    document.title = 'Jermingo - Travel Blog | Adventures, Tips & Stories';
    
    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', 
      'Jermingo - A travel blog sharing adventures, travel tips, and stories from around the world. Join us on our journey as we plan our one-year sabbatical in 2028.'
    );
    
    // Add canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', baseUrl);
  }, []);
  
  return (
    <div>
      <div className="travel-map-container">
        <TravelMap />
      </div>
      <div className="blog-list">
        {sorted_blogs.map((blog, index) => (
          <Link key={index} to={`/blog/${blog.url}`} className="blog-link">
            <BlogCard
              title={blog.title}
              excerpt={blog.excerpt}
              date={blog.date}
              author={blog.author}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Home;